import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./react-print.css";

import App from "./App";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import "./scss/_app.scss";
import { Provider } from "react-redux";
import configureStore from "./redux/configureStore";
import Modal from "react-modal";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "leaflet/dist/leaflet.css";

const { store } = configureStore();

const root = ReactDOM.createRoot(document.getElementById("root"));
Modal.setAppElement("#root");

const { REACT_APP_BASE_NAME } = process.env;

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router basename={REACT_APP_BASE_NAME}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <App />
        </LocalizationProvider>
      </Router>
    </Provider>
  </React.StrictMode>
);
